import { ROUTES } from "../utils/constants";

const authConfig = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  onboardingRedirectPath: ROUTES.ROOT.LOG_IN,
  fallbackRedirectPath: ROUTES.ROOT.LOG_IN,
};

export default authConfig;
